module.exports = __webpack_public_path__ + "static/media/ib-logo.73e3218a.svg";